// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1___c0d517c7394acebee02","cls2":"SmallAccountMenuButton-cls2___5c883c1e3df6dfef1b7 SmallAccountMenuButton-cls1___c0d517c7394acebee02"};